import type { Attributes, PendoEvent } from './types.tsx';
import { isPendoReady, logError } from './utils.tsx';

const QUEUE_LIMIT = 50;
let queue: Array<[string, Attributes | undefined]> = [];

const waitForPendoReadiness = () => {
	// This code should not execute on the server.
	if (__SERVER__) {
		return;
	}
	const interval = setInterval(() => {
		if (isPendoReady()) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			queue.forEach(([event, attributes]) => window?.pendo?.track(event, attributes));
			queue = [];
			clearInterval(interval);
		}
	}, 1000);
};

/**
 * @deprecated passing event as string is deprecated, use `sendPendoTrackEvent(event: PendoEvent)` call instead
 */
export function sendPendoTrackEvent(event: string, properties?: Attributes): void;
export function sendPendoTrackEvent(event: PendoEvent): void;
export function sendPendoTrackEvent(event: string | PendoEvent, properties?: Attributes) {
	let pendoEvent;
	let attributes;

	if (typeof event === 'string') {
		pendoEvent = event;
		attributes = properties;
	} else {
		const fullEvent = [event.source, event.actionSubjectAndAction, event.actionSubjectId]
			.filter((part) => part !== undefined)
			.join(' - ');

		pendoEvent = fullEvent;
		attributes = event.attributes;
	}

	try {
		if (isPendoReady()) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.pendo.track(pendoEvent, attributes);
		} else {
			queue.length < QUEUE_LIMIT && queue.push([pendoEvent, attributes]);
			waitForPendoReadiness();
		}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		logError('pendoTrackEvent', err);
	}
}

export const updatePendoVisitorOptions = (metadata: {}) => {
	try {
		if (isPendoReady()) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.pendo.updateOptions(metadata);
		}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		logError('pendoUpdateOptions', err);
	}
};
